import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api } from "../../api/client";
import { useAuth } from "../../context/AuthContext";
import "../../style/pages.css";
import "./Crops.css";

export default function CropDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user, csrfToken } = useAuth();
  const [crop, setCrop] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => { api.getCrops(id).then(setCrop); }, [id]);
  if (!crop) return <div className="empty-state">개체 기록 복호화 중...</div>;
  const handleDelete = async () => {
    if (!window.confirm(`${crop.code} ${crop.name} 기록을 삭제하시겠습니까?\n삭제한 기록은 복구할 수 없습니다.`)) return;
    setDeleting(true);
    setError("");
    try {
      await api.deleteCrop(id, csrfToken);
      navigate("/crops", { replace: true });
    } catch (reason) {
      setError(reason.message);
      setDeleting(false);
    }
  };
  const fallbackSpecimenArt = [
    "⠀⠀⠀⠀⠀⠀⠀⠀⢀⣀⣀⣀⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣀⣀⣀⡀⠀⠀⠀⠀⠀⠀⠀⠀",
    "⠀⠀⠀⠀⠀⢀⣴⣿⣿⣿⣿⣿⣿⣦⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣴⣿⣿⣿⣿⣿⣿⣦⡀⠀⠀⠀⠀⠀",
    "⠀⠀⠀⠀⣰⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣆⠀⠀⠀⠀⠀⠀⠀⠀⣰⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣆⠀⠀⠀⠀",
    "⠀⠀⠀⢰⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡄⠀⠀⠀⠀⠀⠀⢰⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡄⠀⠀⠀",
    "⠀⠀⠀⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⠀⠀⢀⡀⠀⠀⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⠀⠀⠀",
    "⠀⠀⠀⠹⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡿⠃⠀⢠⣿⣿⡄⠀⠹⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡿⠃⠀⠀⠀",
    "⠀⠀⠀⠀⠈⠻⢿⣿⣿⣿⣿⣿⣿⠿⠋⠀⠀⠀⣿⣿⣿⣿⠀⠀⠀⠈⠻⢿⣿⣿⣿⣿⣿⣿⠿⠋⠀⠀⠀⠀",
    "⠀⠀⠀⠀⠀⠀⠀⠈⠉⠛⠛⠉⠁⠀⠀⠀⠀⠀⢸⣿⣿⣿⡇⠀⠀⠀⠀⠀⠀⠈⠉⠛⠛⠉⠁⠀⠀⠀⠀⠀⠀",
    "⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢸⣿⣿⣿⡇⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀",
    "⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣿⣿⣿⣿⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀",
    "⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢻⣿⣿⡟⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀",
    "⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠙⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀",
    `⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀[ ${crop.code} ]⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀`,
  ].join("\n");
  const specimenArt = crop.asciiArt?.trim() || fallbackSpecimenArt;
  return (
    <article className="crop-detail original-record">
      <div className="crop-detail-toolbar"><Link className="back-link" to="/crops">← 데이터베이스로 복귀</Link>{user?.clearance >= 3 && <button className="danger-button" type="button" onClick={handleDelete} disabled={deleting}>{deleting ? "기록 폐기 중..." : "[기록 삭제]"}</button>}</div>
      {error && <div className="crop-register-error" role="alert">! {error}</div>}
      <div className="original-image"><pre aria-hidden="true">{specimenArt}</pre></div>
      <div className="infor-line"><div className="infor-label">개체명</div><div className="infor-value">{crop.name} / 위험등급 {crop.level}</div></div>
      <div className="infor-line"><div className="infor-label">상태</div><div className="infor-value">{crop.status}</div></div>
      <div className="infor-line"><div className="infor-label">크기</div><div className="infor-value">{crop.size}</div></div>
      <div className="infor-line"><div className="infor-label">개체특징</div><div className="infor-value">{crop.description}<br /><br />주요 서식지 : {crop.habitat}<br />최종 목격 : {crop.lastSeen}</div></div>
      <div className="infor-line"><div className="infor-label">대처법</div><div className="infor-value">{crop.protocol}<br /><br />확인된 취약점 : {crop.weakness}</div></div>
    </article>
  );
}
